window.HELP_IMPROVE_VIDEOJS = false;

import 'video.js';
import 'videojs-youtube';
import '@devmobiliza/videojs-vimeo/dist/videojs-vimeo.esm';

import 'ol/ol.css';
import {Icon, Style} from 'ol/style';


/*
 * Detecting scroll position
 */
function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
}

/**
 * @returns {jQuery}
 */
function getBackendComponents() {
    let components = null;

    try {
        components = window.pageeditor.loadedComponents;
    } catch {
        components = $();
    }

    return components;
}

/**
 * Draw OpenStreetMaps
 */
function drawOSM() {
    $('.openstreetmap').each(function(index, element) {
        var el = $(element);

        var mapLayers = [];

        // add the map itself
        mapLayers.push(
            new ol.layer.Tile({
                source: new ol.source.OSM()
            })
        );

        if (el.attr('data-show-border') == '1') {
            // add border layer
            var borderVector = new ol.layer.Vector({
                source: new ol.source.Vector({
                    url: 'stadtgrenze.gpx',
                    format: new ol.format.GPX(),
                }),
                style: new ol.style.Style({
                    stroke: new ol.style.Stroke({
                        color: '#' + el.attr('data-border-color'),
                        width: 3,
                    }),
                })
            });

            mapLayers.push(borderVector);
        }

        // add marker layer
        var markers = new ol.layer.Vector({
            source: new ol.source.Vector(),
            style: new ol.style.Style({
                image: new ol.style.Icon({
                    anchor: [0.5, 1],
                    src: el.attr('data-marker-icon')
                })
            })
        });

        mapLayers.push(markers);

        // Add markers
        for (var i = 0; i < window.osm_addresses.length; i++) {

            console.log(window.osm_addresses[i]['customicon']);

            var marker = new ol.Feature({
                geometry: new ol.geom.Point(
                    ol.proj.fromLonLat(
                        [
                            window.osm_addresses[i]['lng'],
                            window.osm_addresses[i]['lat']
                        ]
                    )
                ),
                content: window.osm_addresses[i]['content'],
                title: window.osm_addresses[i]['title']
            });

            marker.setStyle(
                new Style({
                    image: new Icon({
                        crossOrigin: 'anonymous',
                        imgSize: [30, 37],
                        src: window.osm_addresses[i]['customicon'],
                    })
                })
            )

            markers.getSource().addFeature(marker);
        }

        var map = new ol.Map({
            target: el.attr('id'),
            layers: mapLayers,
            view: new ol.View({
                center: ol.proj.fromLonLat([el.attr('data-lng'), el.attr('data-lat')]),
                zoom: el.attr('data-zoom')
            })
        });

        var popupElement = document.getElementById('popup');

        var popup = new ol.Overlay({
            element: popupElement,
            positioning: 'bottom-center',
            stopEvent: false,
            offset: [0, -50],
        });

        map.addOverlay(popup);

        // display popup on click
        map.on('click', function (evt) {
            var feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
                return feature;
            });

            if (feature) {
                var coordinates = feature.getGeometry().getCoordinates();
                popup.setPosition(coordinates);

                $(popupElement).popover({
                    placement: 'top',
                    html: true,
                    content: feature.get('content'),
                    title: feature.get('title')
                });

                $(popupElement).popover('show');
            } else {
                $(popupElement).popover('dispose');
            }
        });

        // change mouse cursor when over marker
        map.on('pointermove', function (e) {
            if (e.dragging) {
                return;
            }

            var pixel = map.getEventPixel(e.originalEvent);
            var hit = map.hasFeatureAtPixel(pixel);
            this.getTargetElement().style.cursor = hit ? 'pointer' : '';
        });
    });
}

/*
 * ======= ready handler ======
 */

global.$.fn.slick = $.fn.slick;

$(document).ready(function(){
    drawOSM();

    try {
        BrowserDetect.init();
    } catch { }
    // console.log("You are using " + BrowserDetect.browser + " with version " + BrowserDetect.version);

    const arrowLeft = "<button class=\"slick-prev slick-arrow\" aria-label=\"Previous\" type=\"button\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"26\" viewBox=\"0 0 196.36 411.98\">\n" +
        "  <g>\n" +
        "    <path d=\"M782.46,280.09a37.82,37.82,0,0,0,38,38c21.36,0,38-16.92,37.93-38.46A38.07,38.07,0,0,0,820,241.86C799.42,241.94,782.43,259.22,782.46,280.09Z\" transform=\"translate(-722.17 -158.03)\"/>\n" +
        "    <path d=\"M820.57,409.93c-20.66-.11-38,16.82-38.11,37.22-.12,21.33,16.62,38.92,37.15,39,21.71.12,38.7-16.55,38.83-38.08A37.82,37.82,0,0,0,820.57,409.93Z\" transform=\"translate(-722.17 -158.03)\"/>\n" +
        "    <path d=\"M918.53,364c0-21.56-16.3-37.93-37.78-37.91a37.58,37.58,0,0,0-37.82,37.67,38.11,38.11,0,0,0,38,38.55C902,402.3,918.52,385.44,918.53,364Z\" transform=\"translate(-722.17 -158.03)\"/>\n" +
        "    <path d=\"M722.17,196a37.74,37.74,0,0,0,37.77,38.24c21.19,0,37.84-16.63,38-38A38.09,38.09,0,0,0,760,158C739.25,158,722.19,175.17,722.17,196Z\" transform=\"translate(-722.17 -158.03)\"/>\n" +
        "    <path d=\"M760,493.76a38.13,38.13,0,1,0,.76,76.25c20.51-.09,37.4-17.58,37.22-38.54A37.9,37.9,0,0,0,760,493.76Z\" transform=\"translate(-722.17 -158.03)\"/>\n" +
        "  </g>\n" +
        "</svg></button>";

    const arrowRight = "<button class=\"slick-next slick-arrow\" aria-label=\"Next\" type=\"button\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"26\" viewBox=\"0 0 196.36 411.98\">\n" +
        "  <g>\n" +
        "    <path d=\"M782.46,280.09a37.82,37.82,0,0,0,38,38c21.36,0,38-16.92,37.93-38.46A38.07,38.07,0,0,0,820,241.86C799.42,241.94,782.43,259.22,782.46,280.09Z\" transform=\"translate(-722.17 -158.03)\"/>\n" +
        "    <path d=\"M820.57,409.93c-20.66-.11-38,16.82-38.11,37.22-.12,21.33,16.62,38.92,37.15,39,21.71.12,38.7-16.55,38.83-38.08A37.82,37.82,0,0,0,820.57,409.93Z\" transform=\"translate(-722.17 -158.03)\"/>\n" +
        "    <path d=\"M918.53,364c0-21.56-16.3-37.93-37.78-37.91a37.58,37.58,0,0,0-37.82,37.67,38.11,38.11,0,0,0,38,38.55C902,402.3,918.52,385.44,918.53,364Z\" transform=\"translate(-722.17 -158.03)\"/>\n" +
        "    <path d=\"M722.17,196a37.74,37.74,0,0,0,37.77,38.24c21.19,0,37.84-16.63,38-38A38.09,38.09,0,0,0,760,158C739.25,158,722.19,175.17,722.17,196Z\" transform=\"translate(-722.17 -158.03)\"/>\n" +
        "    <path d=\"M760,493.76a38.13,38.13,0,1,0,.76,76.25c20.51-.09,37.4-17.58,37.22-38.54A37.9,37.9,0,0,0,760,493.76Z\" transform=\"translate(-722.17 -158.03)\"/>\n" +
        "  </g>\n" +
        "</svg></button>";

    /*
     * Slick slider
     */
    function initSlickSliderFilter() {
        $.merge(getBackendComponents().find('.slick-slider-filter'), $('.slick-slider-filter')).slick({
            dots: false,
            arrows: true,
            autoplay: false,
            slidesToShow: 4,
            infinite: true,
            slidesToScroll: 1,
            rows: 0, //fixes bug with unexpected nested div (https://github.com/kenwheeler/slick/issues/3110)
            //swipe: false,
            // customPaging: function(slider, i) {
            //     var title = $(slider.$slides[i]).data('title');
            //     return '<a class="slider-main__nav-btn" href="javascript:void(0);">'+title+'</a>';
            // },
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        //swipe: true,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        //swipe: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        //swipe: true,
                    }
                }
            ],
            prevArrow: arrowLeft,
            nextArrow: arrowRight
        });
    }

    window.initSlickSliderFilter = initSlickSliderFilter;

    $.merge(getBackendComponents().find('.init-slider-slidegallery'), $('.init-slider-slidegallery')).slick({
        dots: false,
        arrows: true,
        autoplay: false,
        slidesToShow: 4,
        infinite: true,
        slidesToScroll: 1,
        rows: 0, //fixes bug with unexpected nested div (https://github.com/kenwheeler/slick/issues/3110)
        //swipe: false,
        // customPaging: function(slider, i) {
        //     var title = $(slider.$slides[i]).data('title');
        //     return '<a class="slider-main__nav-btn" href="javascript:void(0);">'+title+'</a>';
        // },
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    //swipe: true,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    //swipe: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    //swipe: true,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    //swipe: true,
                }
            }
        ],
        prevArrow: arrowLeft,
        nextArrow: arrowRight
    });

    $.merge(getBackendComponents().find('.init-text-with-image-slider'), $('.init-text-with-image-slider')).slick({
        dots: false,
        arrows: true,
        autoplay: false,
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
        rows: 0, //fixes bug with unexpected nested div (https://github.com/kenwheeler/slick/issues/3110)
        //swipe: false,
        // customPaging: function(slider, i) {
        //     var title = $(slider.$slides[i]).data('title');
        //     return '<a class="slider-main__nav-btn" href="javascript:void(0);">'+title+'</a>';
        // },
        prevArrow: arrowLeft,
        nextArrow: arrowRight
    });



    $.merge(getBackendComponents().find('.slick-slider-four'), $('.slick-slider-four')).slick({
        dots: false,
        arrows: true,
        autoplay: false,
        slidesToShow: 4,
        infinite: true,
        slidesToScroll: 1,
        rows: 0, //fixes bug with unexpected nested div (https://github.com/kenwheeler/slick/issues/3110)
        //swipe: false,
        // customPaging: function(slider, i) {
        //     var title = $(slider.$slides[i]).data('title');
        //     return '<a class="slider-main__nav-btn" href="javascript:void(0);">'+title+'</a>';
        // },
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    //swipe: true,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    //swipe: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    //swipe: true,
                }
            }
        ],
        prevArrow: arrowLeft,
        nextArrow: arrowRight
    });

    //function initSlickSliderThree() {

        $.merge(getBackendComponents().find('.slick-slider-three'), $('.slick-slider-three')).slick({
            dots: false,
            arrows: true,
            autoplay: false,
            slidesToShow: 3,
            infinite: true,
            slidesToScroll: 1,
            rows: 0, //fixes bug with unexpected nested div (https://github.com/kenwheeler/slick/issues/3110)
            //swipe: false,
            // customPaging: function(slider, i) {
            //     var title = $(slider.$slides[i]).data('title');
            //     return '<a class="slider-main__nav-btn" href="javascript:void(0);">'+title+'</a>';
            // },
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        //swipe: true,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        //swipe: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        //swipe: true,
                    }
                }
            ],
            prevArrow: arrowLeft,
            nextArrow: arrowRight
        });
    // };
    //
    // window.initSlickSliderThree = initSlickSliderThree;


    // function initSlickSliderTwo() {

        $.merge(getBackendComponents().find('.slick-slider-two'), $('.slick-slider-two')).slick({
            dots: false,
            arrows: true,
            autoplay: false,
            slidesToShow: 2,
            infinite: true,
            slidesToScroll: 1,
            rows: 0, //fixes bug with unexpected nested div (https://github.com/kenwheeler/slick/issues/3110)
            //swipe: false,
            // customPaging: function(slider, i) {
            //     var title = $(slider.$slides[i]).data('title');
            //     return '<a class="slider-main__nav-btn" href="javascript:void(0);">'+title+'</a>';
            // },
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        //swipe: true,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        //swipe: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        //swipe: true,
                    }
                }
            ],
            prevArrow: arrowLeft,
            nextArrow: arrowRight
        });
    // };
    //
    // window.initSlickSliderTwo = initSlickSliderTwo;


    // function initSlickSliderOne() {

        $.merge(getBackendComponents().find('.slick-slider-one'), $('.slick-slider-one')).slick({
            dots: true,
            arrows: true,
            autoplay: false,
            slidesToShow: 1,
            infinite: true,
            slidesToScroll: 1,
            rows: 0, //fixes bug with unexpected nested div (https://github.com/kenwheeler/slick/issues/3110)
            //swipe: false,
            // customPaging: function(slider, i) {
            //     var title = $(slider.$slides[i]).data('title');
            //     return '<a class="slider-main__nav-btn" href="javascript:void(0);">'+title+'</a>';
            // },
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        //swipe: true,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        //swipe: true,
                        dots: false,
                        adaptiveHeight: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        //swipe: true,
                        dots: false,
                        adaptiveHeight: true,
                    }
                }
            ],
            prevArrow: arrowLeft,
            nextArrow: arrowRight
        });
    // };
    //
    // window.initSlickSliderOne = initSlickSliderOne;
    // initSlickSliderOne();

    $.merge(getBackendComponents().find('.themepic-slider'), $('.themepic-slider')).slick({
        dots: true,
        arrows: false,
        autoplay: true,
        infinite: true,
        rows: 0, //fixes bug with unexpected nested div (https://github.com/kenwheeler/slick/issues/3110)
    });


    /*
     * Custom mobile nav
     */
    $(".icon-unfold").click(function(){

        $(this).toggleClass("icon-unfold--down");

        $(this).parents().closest('li').find('dropdown').addClass("open");

        let dropdown = $(this).next();

        dropdown.slideToggle();

    });


    /*
     * Mega-Dropdown
     */
    // $(".level2 li").hover(function(){
    //
    //         $(this).find('.level3').toggleClass("level3-active");
    //
    //
    // });


    // $(".level2 li").hover(function(){
    //
    //     $(this).find('.level3').addClass("level3-active");
    //     //$(this).not(this).removeClass("level3-active");
    //
    //     //$('.level3').not(this).addClass("other");
    //
    // });
    //
    // $(".level2 li").mouseleave(function(){
    //
    //     //setTimeout(function() {
    //         $(this).find('.level3').delay(1000).removeClass("level3-active");
    //     //},1000);
    //     //$(this).not(this).removeClass("level3-active");
    //
    //     //$('.level3').not(this).addClass("other");
    //
    // });

    // mobile Suche
    $(".search-toggle").click(function(){

        //$(".search-outer").toggleClass("open");
        $(this).toggleClass("search-toggle-close");
        $('.search-outer').toggleClass("open");
    });


    /*
     * Fancybox
     */
    $(".fancybox").magnificPopup({type:'image'});


    $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,

        fixedContentPos: false
    });

    // Horizontale Navigation anpinnen
    let header = $('.header');
    let navouter = $('.nav-outer');
    let headerHeight = header.outerHeight();
    $(window).scroll(function(){
        let scrollPosToTop = $(this).scrollTop();
        if (scrollPosToTop > headerHeight){
            header.addClass('fixed');
            navouter.addClass('fixed');
        } else {
            header.removeClass('fixed');
            navouter.removeClass('fixed');
        }
    });

    //$('.wysiwyg-content').find('img:first').addClass('firstimage');
    $('.wysiwyg-content:first').find('img:first').addClass('firstimage');


    if (window.innerWidth > 992) {
        //Aktivierung jquery Menu Aim Plugin
        $(".menuaim").menuAim({
            activate: activateSubmenu,
            deactivate: deactivateSubmenu,
            submenuDirection: "right"
        });
        function activateSubmenu(row) {
            let $row = $(row),
                submenuId = $row.data("submenuId"),
                $submenu = $("#" + submenuId);
            //Submenü anzeigen
            $submenu.css("display", "block");
        }
        function deactivateSubmenu(row) {
            let $row = $(row),
                submenuId = $row.data("submenuId"),
                $submenu = $("#" + submenuId);
            // Submenü ausblenden
            $submenu.css("display", "none");
        }
    }


    $('.slidegallery--item').magnificPopup({
        type: 'image',
        gallery:{
            enabled: true
        },
        image: {
            titleSrc: function(item) {
                return item.el.attr('mfp-title') + '<br>' + item.el.attr('mfp-src');
            }
        }
    });

    $('.estate-gallery-item').magnificPopup({
        type: 'image',
        gallery:{
            enabled: true
        },
        image: {
            titleSrc: function(item) {
                return item.el.attr('mfp-src');
            }
        }
    });

    $('.level1>.dropdown').hoverIntent(function(){
        $(this).toggleClass('open-dd');
    }, {
        sensitivity: 4
    });

    $('#main-nav li:has(".icon-unfold")').doubleTapToGo();


    if ($('#detect-position').length) {
        let options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 10000
        };

        $(this).on('click', function() {

            let out = document.getElementById("detectionHint");

            function error(err) {
                console.warn(`ERROR(${err.code}): ${err.message}`);
            }

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(showPosition, error, options);
            } else {
                out.innerHTML = "Geolocation wird von diesem Browser nicht unterstützt.";
                out.style.display ="block";
            }

            function showPosition(position) {
                $('input[name="lat"]').val(position.coords.latitude);
                $('input[name="lng"]').val(position.coords.longitude);
            }

        });
    }

    // NUR FÜR WOHNBAUMESSE DIGITAL 2021:
    if ($('#wbm-wrapper').length) {
        let windowWidth     = $(window).width();
        let wbmNav          = $('.wbm-nav');
        let headerHeight    = $('.header').outerHeight();
        let wbmHeaderHeight = $('.wbm-header').outerHeight();

        $(window).resize(function () {
            windowWidth     = $(window).width();
            headerHeight    = $('.header').outerHeight();
            wbmHeaderHeight = $('.wbm-header').outerHeight();
        });

        $(window).scroll(function () {
            let scrollPosToTop    = $(this).scrollTop();
            let fixedHeaderHeight = 0;

            if (windowWidth > 991 && windowWidth < 1200) {
                if ($('.header-fixed').length) {
                    fixedHeaderHeight = $('.header-fixed').outerHeight();
                }

                if (scrollPosToTop > (headerHeight + fixedHeaderHeight + wbmHeaderHeight + 26)) {
                    wbmNav.addClass('fixed');
                } else {
                    wbmNav.removeClass('fixed');
                }
            } else if (windowWidth > 1199) {
                if ($('.header-fixed').length) {
                    fixedHeaderHeight = $('.header-fixed').outerHeight();
                }

                if (scrollPosToTop > (headerHeight + fixedHeaderHeight + wbmHeaderHeight - 27)) {
                    wbmNav.addClass('fixed');
                } else {
                    wbmNav.removeClass('fixed');
                }
            } else {
                if (scrollPosToTop > (headerHeight + wbmHeaderHeight)) {
                    wbmNav.addClass('fixed');
                } else {
                    wbmNav.removeClass('fixed');
                }
            }
        });
    }
    // ENDE SCRIPT WOHNBAUMESSE DIGITAL 2021


    $('.datepicker').datetimepicker({
        useCurrent: false,
        locale: 'de',
        format: 'DD.MM.YYYY',
        multidate: true,
    });
});


